<template>
    <div class="foot">
        <div class="links-wrapper">
            <ul class="links">
                <li class="link"><router-link to="/">首 頁</router-link></li>
                <li class="link"><a href="/ActivityList">課程及活動</a></li>
                <li class="link"><a href="/LiteratureList">學術及文化</a></li>
                <li class="link"><a href="/ActivityPhotos/list">活動照片</a></li>
                <li class="link"><a href="/explain">帳號聲明</a></li>
                <li class="link"></li>
                <li v-if="association.introduce" class="link"><a href="/AboutUs#section0" v-text="association.introduce1"></a></li>
                <li v-if="association.concept" class="link"><a href="/AboutUs#section1" v-text="association.concept1"></a></li>
                <li v-if="association.regulation" class="link"><a href="/AboutUs#section2" v-text="association.regulation1"></a></li>
                <li class="link"><a href="/Organization">架構及成員</a></li>
                <li class="link"><a href="/JoinUs">加入學會</a></li>
                <li class="link"><a href="/News/list?CatID=6">學會訊息</a></li>
                <li class="link"><a href="/News/list?CatID=7">學會課程</a></li>
                <li class="link"><a href="/News/list?CatID=8">活動預告</a></li>
                <li class="link"><a href="/News/list?CatID=9">醫學新聞</a></li>
                <li class="link"><a href="/News/list?CatID=10">健康資訊</a></li>
            </ul>
        </div>
        <div class="infos-warpper">
            <div class="infos">
                <qrcode :value="host" :options="{width: 80, color: { dark: '#0275d8' } }"></qrcode>
                <div class="col" v-if="association">
                    <div class="row">
                        <span class="tag tel" v-text="`Tel: ${association.tel}`"></span>
                        <span class="tag fax" v-text="`Fax: ${association.fax}`"></span>
                    </div>
                    <div class="tag email" v-text="`Email: ${association.email}`"></div>
                    <div class="tag address" v-text="`地址: ${association.address}`"></div>
                </div>
                <div class="from">
                    <div>Copyright ©{{ new Date().getFullYear() }} 版權所有&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    <div class="server">服務由&nbsp;<a href="http://www.ectcm.com" target="_blank"><img src="../assets/imgs/img_logo.png" alt=""></a>&nbsp;提供</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                host: location.origin,
                menuIndex: 1,
                checkedIndex: 0,
                association: this.$store.getters.association,
            }
        },
        mounted: function(){
        },
        watch: {
        }
    }
</script>

<style scoped>
    .foot {
        width: 100%;
        background-color: #fff;
        margin-top: 10px;
        font-size: 12px;
        color: #1f1f1f;
        font-weight: 400;
    }

    .foot .links-wrapper {
        background-color: #333;
    }

    .foot .links {
        color: #fff;
        padding: 8px 0px;
        width: 1000px;
        margin: 0 auto;
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 33.3% 33.3% 33.3%;
        grid-template-rows: 24px 24px 24px 24px 24px;
    }

    .foot .links > .link {
        height: 24px;
        line-height: 24px;
    }

    .foot .infos-warpper {
        background-color: #fefefe;
    }

    .foot .infos {
        padding: 8px 0px;
        width: 1000px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
    }

    .foot .infos > img {
        display: inline-block;
        width: 80px;
        height: 80px;
    }

    .foot .infos > .col {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
    }

    .foot .infos > .col .tag {
        height: 26px;
        line-height: 26px;
    }

    .foot .infos .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .foot .infos .row .fax {
        align-self: flex-end;
    }

    .foot .infos .from {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    .foot .infos .from img {
        width: 115px;
        height: 35px;
        vertical-align: bottom;
    }

    .foot .infos .from .server {
        font-size: 14px;
        font-weight: bold;
        color: #232323;
        display: flex;
        align-items: center;
    }

    @media only screen and (max-width: 1050px) {
        .foot .links {
            width: 100%;
        }

        .foot .infos {
            width: 100%;
            position: relative;
            padding-bottom: 100px;
            padding-left: 12px;
            padding-right: 12px;
            box-sizing: border-box;
        }

        .foot .links-wrapper {
            padding: 0 12px;
            box-sizing: border-box;
        }

        .foot .infos .from {
            position: absolute;
            top: 110px;
            white-space: nowrap;
        }

        .foot .infos > .col .tag.address {
            line-height: unset;
        }

        .foot .infos .from img{
            width: 84px;
        }
    }
</style>
